/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_CreditsInputs */

const en_admin_nav_credits = /** @type {(inputs: Admin_Nav_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Admin_Nav_CreditsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_credits = /** @type {((inputs?: Admin_Nav_CreditsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_CreditsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_credits(inputs)
});
export { admin_nav_credits as "admin.nav.credits" }